// extracted by mini-css-extract-plugin
module.exports = {"moveToSpSite":"moveToSpSite"};